module.exports = __webpack_public_path__ + "img/详情页头图.ebdc989a.png";